// extracted by mini-css-extract-plugin
module.exports = {"button":"BeneficiaryForm-module__button--EdvxN","buttonContainer":"BeneficiaryForm-module__buttonContainer--1xbIq"};